// utils
import getAbsoluteBoundingRect from '../../utils/getAbsoluteBoundingRect'

export default {
    name: 'app-scroll-object',

    props:
    {
        content: { type: null, default: null },
        ratio: { type: Number, default: 1 },
        scale: { type: Number, default: 1 },
        autoScale: { type: Boolean, default: true },
        scaleMax: { type: Number, default: 1 },
        isCentered: { type: String, default: '' },

        isParallax: { type: Boolean, default: false },
        isScalling: { type: Boolean, default: false },
        isScroll: { type: Boolean, default: false },
        parallaxRatio: { type: Number, default: 0.075 },

        hasTilling: { type: Boolean, default: false },

        nodeActiveClass: { type: String, default: 'el' },

        debug: { type: Boolean, default: false },

        offset: { type: Number, default: 0 }
    },

    data()
    {
        return {
            isActive: false
        }
    },

    created()
    {
        this._height = 0
        this._offsetY = 0

        this._fullOffsetY = 0

        this._currScrollTop = 0

        this._securityMerge = this.$root.isTouch ? 200 : 0

        this.eventHub.$on('window:resize', this._onResize)
        this.eventHub.$on('application:scroll-enabled', this._onResize)
        this.eventHub.$on('window:raf', this._onEnterFrame)
    },

    mounted()
    {
        this.$child = this.$el.children[0]

        if (this.nodeActiveClass === 'el')
        {
            this.$node = this.$el
        }
        else if (this.nodeActiveClass === 'parent')
        {
            this.$node = this.$el.parentElement
        }

        this._onResize()
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this._onResize)
        this.eventHub.$off('application:scroll-enabled', this._onResize)
        this.eventHub.$off('window:raf', this._onEnterFrame)
    },

    methods: {
        _onResize()
        {
            this.$nextTick(() =>
            {
                this._height = this.$el.offsetHeight
                this._offsetY = getAbsoluteBoundingRect(this.$el).top

                this._fullOffsetY = this._height + this._offsetY

                if (this.autoScale)
                {
                    this._scale = this._height > 0 ? Math.round(((this._height + (this.$root.height * this.parallaxRatio * 2)) / this._height) * 100) / 100 : 1

                    if (this._scale < 1)
                    {
                        this._scale = 1
                    }
                }
                else
                {
                    this._scale = this.scale
                }

                if (this.debug)
                {
                    console.log(this.$el, this._scale, this._height, this.$root.height, this.parallaxRatio)
                }
            })
        },

        _onEnterFrame()
        {
            if (this.isScroll
                && !this.$root.isTouch)
            {
                if (this.isCentered === 'x')
                {
                    this.$el.style.transform = `translateX(-50%) translateY(${Math.round(-this.$root.smoothScroll * this.ratio * 100) / 100}px) translateZ(0)`
                }
                else if (this.isCentered === 'y')
                {
                    this.$el.style.transform = `translateY(calc(-50% + ${Math.round(-this.$root.smoothScroll * this.ratio * 100) / 100}px)) translateZ(0)`
                }
                else if (this.isCentered === 'xy')
                {
                    this.$el.style.transform = `translateX(-50%) translateY(calc(-50% + ${Math.round(-this.$root.smoothScroll * this.ratio * 100) / 100}px)) translateZ(0)`
                }
                else
                {
                    this.$el.style.transform = `translateY(${Math.round(-this.$root.smoothScroll * this.ratio * 100) / 100}px) translateZ(0)`
                }
            }

            if (this.isParallax)
            {
                const newScrollTop = this._fullOffsetY - this.$root.smoothScroll - this.$root.height
                this._currScrollTop += (newScrollTop - this._currScrollTop) * 0.1

                const translateY = Math.round(-this._currScrollTop * this.parallaxRatio * 100) / 100

                if (this.$root.smoothScroll + this.$root.height >= this._offsetY - this._securityMerge
                    && this.$root.smoothScroll <= this._fullOffsetY)
                {
                    if (!this.isActive)
                    {
                        this.isActive = true
                        this.$node.classList.add('is-active')

                        if (this.debug)
                        {
                            console.log(1, 'isActive')
                        }
                    }

                    if (this.isCentered === 'x')
                    {
                        this.$child.style.transform = `translateX(-50%) translateY(${translateY}px) scale(${this._scale}) translateZ(0)`
                    }
                    else if (this.isCentered === 'y')
                    {
                        this.$child.style.transform = `translateY(${translateY}px) scale(${this._scale}) translateZ(0)`
                    }
                    else if (this.isCentered === 'xy')
                    {
                        this.$child.style.transform = `translateX(-50%) translateY(calc(-50% + ${translateY}px)) scale(${this._scale}) translateZ(0)`
                    }
                    else
                    {
                        this.$child.style.transform = `translateY(${translateY}px) scale(${this._scale}) translateZ(0)`
                    }
                }
                else
                {
                    if (!this.hasTilling)
                    {
                        if (this.isCentered === 'x')
                        {
                            this.$child.style.transform = `translateX(-50%) translateY(${translateY}px) scale(${this._scale}) translateZ(0)`
                        }
                        else if (this.isCentered === 'y')
                        {
                            this.$child.style.transform = `translateY(calc(-50% + ${translateY}px)) scale(${this._scale}) translateZ(0)`
                        }
                        else if (this.isCentered === 'xy')
                        {
                            this.$child.style.transform = `translateX(-50%) translateY(calc(-50% + ${translateY}px)) scale(${this._scale}) translateZ(0)`
                        }
                        else
                        {
                            this.$child.style.transform = `translateY(${translateY}px) scale(${this._scale}) translateZ(0)`
                        }
                    }

                    if (this.isActive)
                    {
                        this.isActive = false

                        if (this.debug)
                        {
                            console.log(2, 'isInActive')
                        }
                    }
                }
            }
            else if (this.$root.smoothScroll + this.$root.height - this.offset >= this._offsetY
                && !this.isScroll
                && this.$root.smoothScroll <= this._fullOffsetY + this._height)
            {
                if (!this.isActive)
                {
                    this.isActive = true
                    this.$node.classList.add('is-active')

                    if (this.debug)
                    {
                        console.log(3, 'isActive')
                    }
                }
            }
            else if (this.isActive)
            {
                this.isActive = false
                this.$node.classList.remove('is-active')
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-scroll-object/script.js